import React, { useState } from 'react';
import {
    Typography,
    TextField,
    Button,
    Card,
    CardContent,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions
} from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2';
import emailjs from 'emailjs-com';

// Définir une interface pour les props
interface ContactUsPopupProps {
    open: boolean; // Indique si le dialogue est ouvert ou non
    onClose: () => void; // Fonction à appeler pour fermer le dialogue
}

const ContactUsPopup: React.FC<ContactUsPopupProps> = ({ open, onClose }) => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        compagny: '',
        phoneNumber: '',
        message: '',
    });

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        emailjs.send(
            'service_bd6pp67',   // Remplacez par le SERVICE_ID EmailJS
            'template_42xmkpc',  // Remplacez par le TEMPLATE_ID EmailJS
            formData,
            'e-ybTJj1CPzfHM6VG'  // Remplacez par le USER_ID EmailJS
        )
            .then((result) => {
                console.log('Email envoyé:', result.text);
                alert('Votre message a été envoyé avec succès !');
                onClose(); // Fermer la popup après l'envoi
                // Réinitialiser les champs du formulaire
                setFormData({
                    name: '',
                    email: '',
                    compagny: '',
                    phoneNumber: '',
                    message: '',
                });
            })
            .catch((error) => {
                console.log('Erreur lors de l\'envoi de l\'e-mail:', error.text);
                alert('Erreur lors de l\'envoi du message. Veuillez réessayer.');
            });
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle variant="h4" sx={{ fontWeight: 'bold', fontFamily: 'monospace' }}>Contactez-nous !</DialogTitle>
            <DialogContent>
                <Card sx={{ boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.5)', borderRadius: 5, mt: 2 }}>
                    <CardContent>
                        <Typography sx={{ fontFamily: 'unset' }}>
                            Un souci électrique ? Un devis en tête ? Un coup de fil suffit !
                        </Typography>
                        <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 1, fontFamily: 'unset' }}>
                            Entrer en contact
                        </Typography>
                        <Typography variant="body1" sx={{ mb: 1, fontFamily: 'unset' }}>
                            Compléter le formulaire :
                        </Typography>
                        <form onSubmit={handleSubmit}>
                            <Grid2 container spacing={2}>
                                <Grid2 xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label="Votre nom"
                                        name="name"
                                        variant="outlined"
                                        value={formData.name}
                                        onChange={handleChange}
                                        required
                                        InputProps={{
                                            sx: {
                                                borderRadius: 5,
                                                fontFamily: 'inherit'
                                            },
                                        }}
                                    />
                                </Grid2>
                                <Grid2 xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label="Votre société"
                                        name="compagny"
                                        onChange={handleChange}
                                        variant="outlined"
                                        value={formData.compagny}
                                        InputProps={{
                                            sx: {
                                                borderRadius: 5,
                                                fontFamily: 'inherit'
                                            },
                                        }}
                                    />
                                </Grid2>
                                <Grid2 xs={12}>
                                    <TextField
                                        fullWidth
                                        label="Votre email"
                                        variant="outlined"
                                        name="email"
                                        onChange={handleChange}
                                        type="email"
                                        value={formData.email}
                                        required
                                        InputProps={{
                                            sx: {
                                                borderRadius: 5,
                                                fontFamily: 'inherit'
                                            },
                                        }}
                                    />
                                </Grid2>
                                <Grid2 xs={12}>
                                    <TextField
                                        fullWidth
                                        label="Numéro de téléphone"
                                        variant="outlined"
                                        name="phoneNumber"
                                        onChange={handleChange}
                                        type="tel"
                                        value={formData.phoneNumber}
                                        required
                                        InputProps={{
                                            sx: {
                                                borderRadius: 5,
                                                fontFamily: 'inherit'
                                            },
                                        }}
                                    />
                                </Grid2>
                                <Grid2 xs={12}>
                                    <TextField
                                        fullWidth
                                        label="Comment pouvons-nous vous aider ?"
                                        variant="outlined"
                                        name="message"
                                        value={formData.message}
                                        onChange={handleChange}
                                        multiline
                                        rows={2}
                                        InputProps={{
                                            sx: {
                                                borderRadius: 5,
                                                fontFamily: 'inherit'
                                            },
                                        }}
                                    />
                                </Grid2>
                                <Grid2 xs={12}>
                                    <Button
                                        type={"submit"}
                                        fullWidth
                                        variant="contained"
                                        sx={{
                                            backgroundColor: '#3f72b5',
                                            color: '#fff',
                                            borderRadius: 5,
                                            fontFamily: 'unset'
                                        }}
                                    >
                                        Envoyer
                                    </Button>
                                </Grid2>
                            </Grid2>
                        </form>
                    </CardContent>
                </Card>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Annuler</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ContactUsPopup;
